import { Anchor as AntdAnchor } from 'antd';
import {
  AnchorProps as AntdAnchorProps,
  AnchorLinkProps as AntdAnchorLinkProps,
} from 'antd/lib/anchor';

export type AnchorProps = AntdAnchorProps;
export type AnchorLinkProps = AntdAnchorLinkProps;

export const Anchor = AntdAnchor;

export default Anchor;
